import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Button from '@wix/da-shared-react/pkg/Button';
import s from './DisabledOverlay.scss';

export interface Props {
  className?: string;
  total: number;
  enableAllCommissions(): void;
}

export function DisabledOverlay({
  className,
  total,
  enableAllCommissions,
}: Props) {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      <div className={classnames(s['content'], className)}>
        <span className={s['title']}>
          {t('pages.shop.disabledState.commissions.titleOwner')}
        </span>
        <span className={s['subtitle']}>
          {t('pages.shop.disabledState.commissions.subtitleOwner', {
            count: total,
          })}
        </span>
        <Button view="b9" onClick={enableAllCommissions}>
          {t('pages.shop.disabledState.commissions.enableAllCommissions')}
        </Button>
      </div>
    </div>
  );
}

export default DisabledOverlay;
